import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';
import Icon from 'apps/new-web/views/components/icon';
import { blueGray80, white } from 'apps/new-web/views/themes/colors';
import baptize from 'lib/baptize';

const WorkoutIcon = ({ icon, mediaType, ariaLabelDescription, titleDescription, stat, showAsTime, system }) => {
  function formatTimeSR(seconds) {
    const srSeconds = I18n.translate('seconds');
    const srMinutes = I18n.translate('minutes');
    //secToMin
    const minutesSeconds = baptize.secToMin(seconds, system, true, 1).slice(0, 4).replace('min', '').replace(',', ':');
    const minutesStr = minutesSeconds.slice(0, 1);
    const secondsStr = minutesSeconds.slice(2);
    return `${minutesStr} ${srMinutes}, ${secondsStr} ${srSeconds}.`;
  }

  function validDurationString(seconds) {
    const minutesSeconds = baptize.secToMin(seconds, system, true, 1).slice(0, 4).replace('min', '').replace(',', ':');
    const minutesStr = minutesSeconds.slice(0, 1);
    const secondsStr = minutesSeconds.slice(2);
    return `PDT0H${minutesStr}M${secondsStr}S`;
  }

  function msToMinutes(milliseconds) {
    const resultString = baptize.secToMin(milliseconds, 'standard', true, 1)
      .slice(0, 4).replace('min', '').replace(',', ':');
    const parts = resultString.split(':');
    const minutes = parts[0];
    const seconds = Math.floor(parts[1] * .01 * 60);
    const paddedSeconds = String(seconds).padStart(2, '0');
    return `${minutes}:${paddedSeconds}`;
  }

  return (
    <li>
      <Icon
        icon={ icon }
        color={ mediaType === 'mobile' ? white : blueGray80 }
        size={ mediaType === 'mobile' ? 20 : 28 }
      />
      { ariaLabelDescription ?
        <h3
          className="title"
          aria-label={ I18n.translate(ariaLabelDescription.text, ariaLabelDescription.context) }
        >
          <I18n desc={ titleDescription.context } args={{ text: titleDescription.text }}>[text]</I18n>
        </h3>
        :
        <h3
          className="title"
        >
          <I18n desc={ titleDescription.context } args={{ text: titleDescription.text }}>[text]</I18n>
        </h3>
      }
      { showAsTime &&
        <React.Fragment>
          <time
            dateTime={ validDurationString(stat.text) }
            className="stat"
            aria-label={ formatTimeSR(stat.ariaLabel) }
          >
            { msToMinutes(stat.text) }
          </time>
          { icon.name === 'PACE_LINE' &&
            <span className="sr-only"><I18n desc="Sentence fragment giving a measurement. Ex. '12 minutes per mile.'"> minutes per mile</I18n></span>
          }
        </React.Fragment>
      }
      { !showAsTime &&
      <p className="stat">
        { stat.text }
        { (stat.desc || stat.ariaLabel) && (
          <span className="sr-only"><I18n desc={ stat.desc } args={{ text: stat.ariaLabel }}>[text]</I18n></span>
        )}
      </p>
      }
    </li>
  );
};

WorkoutIcon.propTypes = {
  icon: PropTypes.string,
  mediaType: PropTypes.user,
  ariaLabelDescription: PropTypes.object,
  titleDescription: PropTypes.object,
  stat: PropTypes.string,
  showAsTime: PropTypes.bool.isRequired,
  system: PropTypes.string
};

WorkoutIcon.defaultProps = {
  showAsTime: false,
  system: 'standard'
};

export default WorkoutIcon;
